import { createFileRoute } from '@tanstack/react-router'
import type { SchemaExplorerSearchParams } from 'grafbase-components/schema-explorer'
import {
  type GenericSchema,
  literal,
  number,
  object,
  optional,
  parse,
  string,
  union,
} from 'valibot'
import node, { type schemaPageQuery } from '#gen/relay/schemaPageQuery.graphql'
import { ErrorHandler } from '#lib/errors/errors'
import { lazyLoadedComponent } from '#lib/routing/lazy-loaded-component'

const SearchParamsSchema = object({
  schemaTab: optional(
    union([
      literal('api-schema'),
      literal('federated-schema'),
      object({
        subgraph: string(),
      }),
    ]),
  ),
  search: optional(string()),
  cursorPosition: optional(number()),
  gotoNode: optional(
    union([
      object({
        typeName: string(),
      }),
      object({
        fieldName: string(),
        parentType: string(),
      }),
      object({
        directiveName: string(),
      }),
    ]),
  ),
  gotoPosition: optional(
    object({
      line: number(),
      column: number(),
    }),
  ),
  gotoOffset: optional(number()),
}) satisfies GenericSchema<SchemaExplorerSearchParams>

export const Route = createFileRoute(
  '/_dashboard/$account/graphql/$graph/branches/$branch/schema',
)({
  staticData: { title: '[graph] - Schema' },
  errorComponent: ErrorHandler,

  validateSearch(search) {
    return parse(SearchParamsSchema, search)
  },

  loaderDeps(opts) {
    return {
      schemaTab: opts.search.schemaTab ?? 'api-schema',
    }
  },

  loader({ deps, context, params }) {
    return context.preload<schemaPageQuery>(node, {
      account: params.account,
      graph: params.graph,
      branch: params.branch,
      includeApiSchema: deps.schemaTab === 'api-schema',
      subgraphName:
        typeof deps.schemaTab === 'object' ? deps.schemaTab.subgraph : '',
      fetchSubgraph: typeof deps.schemaTab === 'object',
    })
  },
  component: lazyLoadedComponent(
    () => import('#app/pages/schema/schema-page'),
    'SchemaPage',
  ),
})
